import HubIcon from '@mui/icons-material/Hub'
import CollaborationsCreate from './Collaborations.create'
import CollaborationsEdit from './Collaborations.edit'
import CollaborationsList from './Collaborations.list'
import CollaborationsShow from './Collaborations.show'

const resource = {
  list: CollaborationsList,
  edit: CollaborationsEdit,
  show: CollaborationsShow,
  create: CollaborationsCreate,
  icon: HubIcon,
}

export default resource
